import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledCarousel } from "reactstrap";

// Core Components
import { hpos } from "../../assets/data/photos";

function CarouselSection() {
  return (
    <>
      <div
        className="section"
        style={{
          backgroundImage:
            "url(" + require("assets/img/ill/testimonial_bg.svg") + ")",
        }}
      >
        <Container className="py-md">
          <Row className="justify-content-between align-items-center">
            <Col className="mb-lg-auto" lg="6">
              <div className="rounded overflow-hidden transform-perspective-left">
                <UncontrolledCarousel items={hpos} />
              </div>
            </Col>
            <Col className="mb-5 mb-lg-0" lg="5">
              <h1 className="font-weight-light">Hannah's Place of Saftey</h1>
              <p className="lead mt-4">
                We decided to run this distance because we needed motivation to
                continue doing what we love. <br />
                2020 was tough and the idea was born while we were having
                coffee. Let's run for a cause, we then done some spade work and
                came across HPOS. We saw what they were doing and immediately
                thought that's the perfect motivation for us.
              </p>
              <Button
                className="btn-white mt-4"
                color="default"
                href="https://www.hannahsplaceofsafety.org/"
                target="_blank"
              >
                Visit HPOS
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CarouselSection;
